/**
 * Helper functions para gerenciar cores de badges e status
 * no módulo de Solicitações de Transporte
 */

/**
 * Retorna as cores da badge baseado no status da solicitação
 * @param {string} solicType - Tipo/status da solicitação
 * @returns {object} Objeto com background-color e color
 */
export const getBadgeColor = solicType => {
  const colorMap = {
    new_solicitations: {
      'background-color': '#E7E3FC1A',
      color: '#E7E3FC',
    },
    'não iniciada': {
      'background-color': '#E7E3FC1A',
      color: '#E7E3FC',
    },
    in_checklist: {
      'background-color': '#FFB4001A',
      color: '#FFB400',
    },
    'em checklist': {
      'background-color': '#FFB4001A',
      color: '#FFB400',
    },
    in_trip: {
      'background-color': '#16B1FF1A',
      color: '#16B1FF',
    },
    'em trânsito': {
      'background-color': '#16B1FF1A',
      color: '#16B1FF',
    },
    'em viagem': {
      'background-color': '#16B1FF1A',
      color: '#16B1FF',
    },
    cancelada: {
      'background-color': '#FF4D4D1A',
      color: '#FF4D4D',
    },
    cancelled: {
      'background-color': '#FF4D4D1A',
      color: '#FF4D4D',
    },
    done: {
      'background-color': '#56CA001A',
      color: '#56CA00',
    },
    finalizada: {
      'background-color': '#56CA001A',
      color: '#56CA00',
    },
    'aguardando iniciar': {
      'background-color': '#9A62FD1A',
      color: '#9A62FD',
    },
  }

  return colorMap[solicType.toLowerCase()] || {
    'background-color': '#E7E3FC1A',
    color: '#E7E3FC',
  }
}

/**
 * Retorna as cores da badge baseado no status do checklist
 * @param {string} ChecklistStatus - Tipo/status do checklist
 * @returns {object} Objeto com border e color
 */
export const getBadgeChecklistColor = ChecklistStatus => {
  const colorMap = {
    'aguardando inicio': {
      border: 'solid 1px #E7E3FC1A',
      color: '#E7E3FC',
    },
    'checklist concluído': {
      border: 'solid 1px #56CA001A',
      color: '#56CA00',
    },
    'checklist cancelado': {
      border: 'solid 1px #FF4C511A',
      color: '#FF4C51',
    },
    'checklist com não conformidades': {
      border: 'solid 1px #FFB4001A',
      color: '#FFB400',
    },
  }

  return colorMap[ChecklistStatus.toLowerCase()] || {
    border: 'solid 1px #E7E3FC1A',
    color: '#E7E3FC',
  }
}

export const getFilledBadgeChecklistColor = ChecklistStatus => {
  const colorMap = {
    pendente: {
      background: '#FFB4001A',
      color: '#FFB400',
    },
    concluído: {
      background: '#56CA001A',
      color: '#56CA00',
    },
    'concluído automaticamente': {
      background: '#FF821A1A',
      color: '#FF821A',
    },
  }

  return colorMap[ChecklistStatus.toLowerCase()] || {
    background: '#E7E3FC1A',
    color: '#E7E3FC',
  }
}

/**
 * Retorna a cor da borda baseado no status da solicitação
 * @param {string} solicType - Tipo/status da solicitação
 * @returns {string} Cor hexadecimal da borda
 */
export const getBorderColor = solicType => {
  const colorMap = {
    new_solicitations: '#E7E3FC1A',
    in_checklist: '#FFB4001A',
    in_trip: '#16B1FF1A',
    done: '#56CA001A',
  }

  return colorMap[solicType] || '#E7E3FC1A'
}

/**
 * Retorna as cores da badge baseado na situação do veículo
 * @param {string} situation - Situação do veículo
 * @returns {object} Objeto com background-color e color
 */
export const getVehicleBadgeColor = situation => {
  const colorMap = {
    'Em trânsito': {
      'background-color': '#16B1FF1A',
      color: '#16B1FF',
    },
    Cancelada: {
      'background-color': '#FF4D4D1A',
      color: '#FF4D4D',
    },
    'Em manutenção': {
      'background-color': '#9A62FD1A',
      color: '#9A62FD',
    },
    Disponível: {
      'background-color': '#56CA001A',
      color: '#56CA00',
    },
  }

  return colorMap[situation] || {
    'background-color': '#E7E3FC1A',
    color: '#E7E3FC',
  }
}

/**
 * Retorna os estilos CSS inline baseado no nome da empresa
 * @param {string} companyName - Nome da empresa
 * @returns {object} Objeto com as propriedades de estilo CSS
 */
export const getCompanyColor = companyName => {
  const colorMap = {
    'MOTOCA IMPERATRIZ': {
      background: '#4f4251',
      color: '#FFB400',
    },
    'MOTOCA AMARANTE': {
      background: '#ADD8E61A',
      color: '#ADD8E6',
    },
    'MOTOCA CIDELÂNDIA': {
      background: '#FF885C1A',
      color: '#FF885C',
    },
    'MOTOCA PORTO FRANCO': {
      background: '#FFCEFF1A',
      color: '#FFCEFF',
    },
    'MOTOCA SENADOR': {
      background: '#74E5A71A',
      color: '#74E5A7',
    },
    'MOTOCA AÇAILÂNDIA': {
      background: '#D97CEB1A',
      color: '#D97CEB',
    },
    'MOTOCA ITINGA': {
      background: '#C2FFE51A',
      color: '#C2FFE5',
    },
    'MOTOCA BOM JESUS': {
      background: '#B7AAFF1A',
      color: '#B7AAFF',
    },
    'MOTOCA GRAJAÚ': {
      background: '#75A5331A',
      color: '#75A533',
    },
    'MOTOCA FORMOSA': {
      background: '#F5F5DC1A',
      color: '#F5F0DC',
    },
    'MOTOCA SÍTIO NOVO': {
      background: '#40E0D01A',
      color: '#40E0D0',
    },
    'MOTOCA ARAME': {
      background: '#A2FF711A',
      color: '#A2FF71',
    },
    'FUJI MOTORS': {
      background: '#6193FF1A',
      color: '#6193FF',
    },
  }

  return colorMap[companyName] || {
    background: '#6193FF1A',
    color: '#6193FF',
  }
}

/**
 * Retorna o estilo CSS baseado no status
 * @param {string} status - Status do item
 * @returns {string} String com estilos CSS inline
 */
export const returnStyleBasedOnStatus = status => {
  const statusStyleMap = {
    Normal: 'background-color: #56CA001a; color: #56CA00;',
    Atenção: 'background-color: #FFB4001A; color: #FFB400;',
    Irregular: 'background-color: #FF4C511a; color: #FF4C51;',
    'Sem informações': 'background-color: #E7E3FC1a; color: #E7E3FC;',
  }

  return statusStyleMap[status] || 'background-color: lightgray; color: black;'
}
